import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ApmTranslatePipe } from '@mitsubishi/core';

import { FieldWrapper, FormlyField } from '@ngx-formly/core';

@Component({
  selector: 'apm-column-wrapper',
  templateUrl: './column-wrapper.component.html',
  styleUrls: ['./column-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ApmTranslatePipe, FormlyField],
})
export class ColumnWrapperComponent extends FieldWrapper {}
